	(() => {
						function a() {
							var e = document.querySelectorAll(".js-lock-padding");
							if (e.length > 0)
									for (var t = 0; t < e.length; t++) e[t].style.paddingRight = r() + "px";
							document.body.classList.add("body-overflow"), document.body.style.paddingRight = r() + "px"
            }


            var r = function() {
							var e = document.createElement("div");
							e.style.visibility = "hidden", e.style.overflow = "scroll", e.style.msOverflowStyle = "scrollbar", document.body.appendChild(e);
							var t = document.createElement("div");
							e.appendChild(t);
							var i = e.offsetWidth - t.offsetWidth;
							return e.parentNode.removeChild(e), i
            };

            function s() {
							setTimeout((function() {
									var e = document.querySelectorAll(".js-lock-padding");
									if (e.length > 0)
											for (var t = 0; t < e.length; t++) e[t].style.paddingRight = "0px";
									document.body.classList.remove("body-overflow"), document.body.style.paddingRight = 0
							}), 400)
            }
                            var e = document.querySelectorAll("[data-navigation]"),
                                t = document.querySelector("[data-filter-mobile]");
                            if (e.length > 0 && t) {
                                ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && document.addEventListener("click", (function(e) {
                                    var t = document.querySelectorAll(".js-filter-dropdown.active");
                                    if (e.target.closest(".js-filter-dropdown") && !e.target.closest(".js-filter-dropdown.active"))
                                        for (var i = 0; i < t.length; i++) t[i].classList.remove("active");
                                    if (e.target.closest(".js-filter-dropdown") && e.target.closest(".js-filter-dropdown").classList.toggle("active"), !e.target.closest(".js-filter-dropdown") && !e.target.closest(".filter-dropdown__body"))
                                        for (var n = 0; n < t.length; n++) t[n].classList.remove("active")
                                })), t && window.innerWidth < 900 && function() {
                                    var e = document.querySelectorAll("[data-spoller-header]"),
                                        t = !0;
                                    if (e.length > 0)
                                        for (var i = function(i) {
                                                var n = e[i];
                                                n.addEventListener("click", (function(e) {
                                                    e.preventDefault(), t && (t = !1, n.classList.toggle("active"), r(n.nextElementSibling), setTimeout((function() {
                                                        t = !0
                                                    }), 500))
                                                }))
                                            }, n = 0; n < e.length; n++) i(n);
                                    var r = function(e) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
                                            if (!e.classList.contains("_slide")) return e.classList.add("_slide"), "none" === window.getComputedStyle(e).display ? s(e, t) : a(e, t)
                                        },
                                        a = function(e) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
                                            e.style.transitionProperty = "height, margin, padding", e.style.transitionDuration = t + "ms", e.style.height = e.offsetHeight + "px", e.offsetHeight, e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, window.setTimeout((function() {
                                                e.style.display = "none", e.style.removeProperty("height"), e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.classList.remove("_slide")
                                            }), t)
                                        },
                                        s = function(e) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
                                            e.style.removeProperty("display");
                                            var i = window.getComputedStyle(e).display;
                                            "none" === i && (i = "block"), e.style.display = i;
                                            var n = e.offsetHeight;
                                            e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, e.offsetHeight, e.style.transitionProperty = "height, margin, padding", e.style.transitionDuration = t + "ms", e.style.height = n + "px", e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), window.setTimeout((function() {
                                                e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.classList.remove("_slide")
                                            }), t)
                                        }
                                }();
                                var i = document.querySelector(".js-header");
                                document.addEventListener("click", (function(e) {
                                    e.target.closest("[data-button]") && !t.classList.contains("is-open") && (t.classList.add("is-open"), i.classList.add("header--filter-opened"), a()), !e.target.closest("[data-filter-mobile]") || e.target.closest(".menu-filter__body") || e.target.closest("[data-button]") || (t.classList.remove("is-open"), i.classList.remove("header--filter-opened"), s()), e.target.closest(".menu-filter__menu-close") && (t.classList.remove("is-open"), i.classList.remove("header--filter-opened"), s())
                                }))
                            }


















	})()